export default "__VITE_ASSET__30a83e74__"